import { render, staticRenderFns } from "./BankSetup.vue?vue&type=template&id=4507ea8a&scoped=true&"
import script from "./BankSetup.vue?vue&type=script&lang=js&"
export * from "./BankSetup.vue?vue&type=script&lang=js&"
import style0 from "./BankSetup.vue?vue&type=style&index=0&id=4507ea8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507ea8a",
  null
  
)

export default component.exports